export default "__VITE_PUBLIC_ASSET__3abc3767__"